import { GAME_ID, REDUX_ACTIONS } from 'a/idiomatica/data/constants';
import { persistStateTypes } from 'a/reducers/persistStateReducer';

const initState = [];

const gameDataReducer = (state = initState, { type, stateData, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      const gameData = stateData[GAME_ID].GameData || {};
      let details = gameData.gameDetails || [];
      if (details instanceof Object) {
        details = Object.values(details);
      }
      return details;
    }

    case REDUX_ACTIONS.UPDATE_GAME_DATA:
      return [...payload];

    default:
      return state;
  }
};

export default gameDataReducer;
